import React from "react";
import { Badge } from "components/ui/badge";
import { CheckCircle, XCircle, Clock, Loader2 } from "lucide-react";
import { STATUS } from "utils/constants";

interface StatusProps {
  status: string;
}

const Status: React.FC<StatusProps> = ({ status }) => {
  const getStatusConfig = (status: string) => {
    const statusKey = status.toUpperCase();
    const label = STATUS[statusKey] || status;

    switch (statusKey) {
      case "SUCCESS":
        return {
          label,
          className:
            "bg-green-100 text-green-800 border-green-200 hover:bg-green-100",
          icon: CheckCircle,
        };
      case "UNSUCCESSFUL":
      case "INVALID":
        return {
          label,
          className: "bg-red-100 text-red-800 border-red-200 hover:bg-red-100",
          icon: XCircle,
        };
      case "PENDING":
      case "POSTPONED":
        return {
          label,
          className:
            "bg-yellow-100 text-yellow-800 border-yellow-200 hover:bg-yellow-100",
          icon: Clock,
        };
      case "IN_PROGRESS":
      case "PARTIAL_SUCCESS":
      case "PENDING_PROCESSING":
      case "PENDING_REVIEW":
      case "PENDING_MANUAL_CALL":
        return {
          label,
          className:
            "bg-blue-100 text-blue-800 border-blue-200 hover:bg-blue-100",
          icon: Loader2,
        };
      case "CANCELLED":
      case "UNKNOWN":
      default:
        return {
          label,
          className:
            "bg-gray-100 text-gray-800 border-gray-200 hover:bg-gray-100",
          icon: Clock,
        };
    }
  };

  const config = getStatusConfig(status);
  const IconComponent = config.icon;

  return (
    <Badge variant="outline" className={config.className}>
      <IconComponent className="h-3 w-3 mr-1" />
      {config.label}
    </Badge>
  );
};

export default Status;
